import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Facebook, Instagram, Twitter, Send, Mail, Phone } from "lucide-react";

export function Footer() {
  const { data: s } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });
  const socials = [
    { icon: Facebook, href: s?.facebook, key: "facebook" },
    { icon: Instagram, href: s?.instagram, key: "instagram" },
    { icon: Twitter, href: s?.twitter, key: "twitter" },
    { icon: Send, href: s?.telegram, key: "telegram" },
  ].filter((x) => x.href);

  return (
    <footer className="relative border-t border-white/10 bg-[#0A0B11] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Premium IPTV streaming with thousands of live channels, movies and series in stunning 4K across all your devices.
          </p>
          <div className="flex gap-3 mt-5">
            {socials.map((soc) => (
              <a key={soc.key} data-testid={`footer-social-${soc.key}`} href={soc.href} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:border-purple-500/40 transition-colors">
                <soc.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/packages" className="hover:text-white">Packages</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/login" className="hover:text-white">Login</Link></li>
            <li><Link to="/register" className="hover:text-white">Register</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-white">Refund Policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            {s?.contact_email && <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-neon-purple" /> {s.contact_email}</li>}
            {s?.contact_phone && <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-neon-purple" /> {s.contact_phone}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500 px-4">
        © {new Date().getFullYear()} Saad IPTV. All rights reserved. Not affiliated with any streaming platform or broadcaster.
      </div>
    </footer>
  );
}
